import auth from '../utils/auth'
import rest from '../utils/rest'

const tokenRequest = {
  scopes: ['openid', 'profile', 'User.Read'],
  forceRefresh: false // set this to "true" if you would like to skip a cached token and go to the server
};

export default {
  async getUserProfile() {
    const url = 'https://graph.microsoft.com/beta/me/';
    const options = await auth.getOptions(tokenRequest, 'GET');

    return await rest.call(url, options);
  },
  async getAppRoleAssignments() {
    //Use Enterprise Application egg picker object Id to app role assignments
    const url = 'https://graph.microsoft.com/beta/me/appRoleAssignments?$filter=resourceId eq 767959f8-7de0-446c-b320-b85fcf83468e';
    const options = await auth.getOptions(tokenRequest, 'GET');
    return await rest.call(url, options);
  }
}